import { TranslateCompiler } from "@ngx-translate/core";

export class CustomCompiler implements TranslateCompiler{
    compileTranslations(translations: any, lang: string) {
        for (let key in translations) {
            let value = translations[key];
            // Use `key` and `value`
            translations[key] = this.compile(value,lang);
        }
        return translations;
    }

    compile(value: string, lang: string): string{
        return value.replace("{0}","{{value0}}").replace("&amp;", "&");
    }
}